import { InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

export type Props = InputHTMLAttributes<HTMLInputElement> & {
    id: string;
    baseUrl: string;
    required?: boolean;
    label?: string;
    labelKey?: string;
};

export const UrlField = ({ required, id, label, labelKey, baseUrl, ...otherProps }: Props) => {
    const { t } = useTranslation();
    return (
        <div className={ required ? 'required field' : 'field' }>
            <label htmlFor={ id }>
                { label || t(labelKey!) }
            </label>
            <div className="ui labeled input">
                <div className="ui label">
                    { baseUrl }
                </div>
                <input
                    id={ id }
                    type="text"
                    { ...otherProps }
                />
            </div>
        </div>
    );
};
